<template>
  <div class="top">
    <!-- <img v-if="lang === 'zh-CN'" src="../../assets/images/new-login-2018/logo@2x.png"> -->
    <img src="../../assets/images/new-login-2018/logo1@2x.png">
    <div class="open-app" v-show="openAppShow" @click="showApp">
      {{ text }}
    </div>
  </div>
</template>

<script type="text/javascript">
  import translate from '../common/Translate.js'
  import { browserLanguage } from '../common/Common'
  import uploadWebEvent from '../common/UploadWebEvent.js'
  export default {
    data () {
      return {
        openAppShow: false,
        text: translate('Open in App'),
        lang: browserLanguage()
      }
    },
    mounted () {
      if (this.$route.path === '/' || this.$route.path === '/invite/invitenext') this.openAppShow = true
    },
    methods: {
      showApp () {
        if (this.$route.path === '/') {
          // 埋点统计：点击app中打开 首页
          uploadWebEvent('OPENAPP', {
            type: 0
          })
        } else if (this.$route.path === '/invite/invitenext') {
          // 埋点统计：点击app中打开 老用户登录页
          uploadWebEvent('OPENAPP', {
            type: 1
          })
        }
        let url
        if (navigator.userAgent.indexOf('Android') > -1) {
          url = 'batchatnew://?cmd=login&type=1&token=' + this.$route.query['token']
        } else {
          url = 'batchat://?cmd=login&type=1&token=' + this.$route.query['token']
        }
        let iframe = document.createElement('iframe')
        let body = document.body
        iframe.style.cssText = 'display:none;width=0;height=0'
        body.appendChild(iframe)
        iframe.src = url
        location.href = url
      }
    }
  }
</script>

<style type="text/css" lang="scss" scoped>
  .top {
    width: 100%;
    height: 50px;
    box-shadow: 0 2px 4px 2px rgba(211, 211, 211, 0.5);
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1;
    padding: 0 15px;
    background: #ffffff;
    img {
      height: 24px;
      float: left;
      margin-top: 13px;
    }
    .open-app {
      min-width: 87px;
      height: 32px;
      background: #3f86de;
      float: right;
      margin-top: 9px;
      color: #ffffff;
      text-align: center;
      line-height: 32px;
      border-radius: 50px;
    }
  }
</style>



// WEBPACK FOOTER //
// Top.vue?92cd4978